import React from 'react';
import { initials } from '../utils/format';

function Avatar({ name = '', size = 32 }) {
  return (
    <div
      className="profile-avatar"
      style={{ width: size, height: size, fontSize: Math.max(11, Math.round(size * 0.4)) }}
      aria-label={name}
    >
      {initials(name) || '?'}
    </div>
  );
}

export default Avatar;
